'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.958 4.893a.337.337 0 0 1 .457 0l4.63 4.212a.34.34 0 0 1 .11.251V20.66c0 .187-.152.34-.34.34H7.558a.34.34 0 0 1-.34-.34V9.356c0-.096.04-.187.11-.25Zm.228.71-4.29 3.903V20.32h1.29v-3.438c0-.125.103-.227.228-.227h2.039c.125 0 .226.102.226.227v3.438h4.797V9.506l-4.29-3.903Zm-.96 11.505H9.64v3.212h1.586v-3.212Zm.736-14.023a.34.34 0 0 1 .449 0l1.946 1.712v-.332h.68v.93l.976.86V3.803h-1.96v-.68h2.949v.68h-.31v3.05l1.68 1.478-.45.51-5.736-5.048L6.449 8.84l-.45-.51Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.903 16.656c.125 0 .226.101.226.226v2.039a.227.227 0 0 1-.226.227h-2.039a.227.227 0 0 1-.227-.227v-2.039c0-.125.102-.226.227-.226h2.039Zm-.226.452h-1.586v1.586h1.586v-1.586Zm.282-3.929c.125 0 .226.1.226.227v2.038a.227.227 0 0 1-.226.227H12.92a.227.227 0 0 1-.227-.227v-2.038c0-.126.102-.227.227-.227h2.039Zm-3.506 0c.125 0 .226.1.226.227v2.038a.227.227 0 0 1-.226.227H9.414a.227.227 0 0 1-.227-.227v-2.038c0-.126.102-.227.227-.227h2.039Zm3.279.453h-1.586v1.586h1.586v-1.586Zm-3.506 0H9.64v1.586h1.586v-1.586Zm3.733-3.903c.125 0 .226.101.226.226v2.039a.226.226 0 0 1-.226.226H12.92a.227.227 0 0 1-.227-.226V9.955c0-.125.102-.226.227-.226h2.039Zm-3.451 0c.126 0 .227.101.227.226v2.039a.226.226 0 0 1-.227.226H9.47a.226.226 0 0 1-.227-.226V9.955c0-.125.101-.226.227-.226h2.038Zm3.224.452h-1.586v1.586h1.586V10.18Zm-3.45 0H9.696v1.586h1.586V10.18Z",
    fill: "currentColor"
  })));
});
var FwSet0Level3 = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Level3 = FwSet0Level3;